module.exports = __webpack_public_path__ + "img/logo-full.1ccbf2ae.svg";